import { SITE_KEY } from '../views/SelfServe/SignUp/utils/constants';

export const getFieldState = (
  errorCondition: unknown,
  isTouched: boolean
): 'error' | 'default' => {
  if (errorCondition && isTouched) {
    return 'error';
  }
  return 'default';
};

export const getFieldDescription = (
  error: string | undefined,
  isTouched: boolean
): string => {
  if (error && isTouched) {
    return error;
  }
  return '';
};

export const getPasswordVisibilityType = (
  passwordVisible: boolean
): 'text' | 'password' => {
  if (passwordVisible) {
    return 'text';
  }
  return 'password';
};

export const getRevealPasswordIconName = (passwordVisible: boolean): string => {
  if (passwordVisible) {
    return 'fa-solid fa-eye';
  }
  return 'fa-solid fa-eye-slash';
};

const RECAPTCHA_LOCAL_DEV_PLACEHOLDER_SITE_KEY = 'sitekey';

export const getRecaptchaSiteKey = (): string => {
  if (SITE_KEY) {
    return SITE_KEY;
  }
  return RECAPTCHA_LOCAL_DEV_PLACEHOLDER_SITE_KEY;
};
